import { useState, useEffect } from 'react'

import { submitSets } from '../components/UiComponents/SubmitSets'

import { submitCollection } from '../_services/submit.service'

const useFetchMultipleAPIs = (apiData) => {
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true)
            try {
                const responses = await Promise.all(
                    apiData.map((url) => submitSets(url?.url, url?.filter))
                )
                setData(responses)
            } catch (err) {
                setError(err.message)
            } finally {
                setIsLoading(false)
            }
        }

        fetchData()
    }, [])

    return { data, isLoading, error }
}

export default useFetchMultipleAPIs
